var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-picker',_vm._g(_vm._b({attrs:{"item-label":"label","item-value":"value"}},'simple-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }